<template>
  <v-app-bar
    app
    clipped-left
    dense
    dark
  >
    <ChangePasswordDialog
      :dialog="showChangePasswordDialog"
      :canCancel="!passwordExpired"
      @close="closeChangePasswordDialog()"
    >
    </ChangePasswordDialog>

    <v-app-bar-nav-icon
      color="white"
      @click="onNavIconClicked"
    >
    </v-app-bar-nav-icon>
    <v-toolbar-title>
      <div>
        <div style="float:left;">Equipment Dashboard</div>
        <div style="float:left;margin-left:-20px;font-size:8px;margin-top:24px">v1.7.5*</div>
      </div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div style="width:300px">
      <v-text-field
        dark
        placeholder="search for equipment serial number"
        single-line
        v-model="searchSerialNumber"
        :append-icon="getSearchIcon()"
        @click:append="onSearchClicked"
        v-on:keyup.enter="onSearchClicked"
        class="mt-4 mr-3"
      >
      </v-text-field>
    </div>

    <v-btn icon><v-icon>notifications</v-icon></v-btn>

    <v-menu bottom left>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>account_circle</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="changePasswordClicked">
          <v-list-item-title>Change Password</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logoutClicked">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import ChangePasswordDialog from './ChangePasswordDialog.vue';

export default {
  components: {
    ChangePasswordDialog,
  },

  props: {
    searching: Boolean,
  },

  data() {
    return {
      searchSerialNumber: '',
      showChangePasswordDialog: false,
      passwordExpired: false,
      checkPasswordExpiredInterval: null,
    };
  },

  mounted() {
    //console.log('AppBar mounted...');

    this.checkPasswordExpired();

    this.checkPasswordExpiredInterval = setInterval(() => {
      console.log('time to check if password is expired');
      this.checkPasswordExpired();
    }, 30 * 60000);
  },

  beforeDestroy() {
    clearInterval(this.checkPasswordExpiredInterval);
  },

  methods: {
    getSearchIcon() {
      return this.searching ? 'hourglass_empty' : 'search';
    },

    onNavIconClicked() {
      this.$emit('toggleNavDrawer');
    },

    onSearchClicked() {
      if (!this.searching && this.searchSerialNumber) {
        this.$emit('search', this.searchSerialNumber);
      }
    },

    changePasswordClicked() {
      console.log('change password');
      this.showChangePasswordDialog = true;
    },

    logoutClicked() {
      localStorage.removeItem('user-token');
      window.location.reload();
    },

    closeChangePasswordDialog() {
      this.showChangePasswordDialog = false;
    },

    checkPasswordExpired() {
      const { username } = this.$store.state.auth.token.user;
      //console.log(`check for password expiration: ${username}`);

      const options = {
        method: 'get',
        url: `/read/expired/v1?username=${username}`,
      };

      this.axios(options)
        .then((res) => {
          if (res.status === 200) {
            //console.log(`isExpired: ${res.data.expired}`);
          } else {
            console.log(`failed to check expiration: ${res.status}`);
          }
        })
        .catch(() => {
          console.log('error checking expiration');
        });
    },
  },
};
</script>

<style scoped>
</style>
